module.exports = __webpack_public_path__ + "img/arrow3.884fec81.svg";